export default "__VITE_ASSET__CiGtjLcQ__"